import { Link } from "react-router-dom";
import { categories, siteIntro } from "@/mocks/gossip";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-primary-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-live-fill w-5 h-5 flex items-center justify-center"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteIntro.brandName}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
              {siteIntro.tagline}。我们收录实拍、第一现场、完整版、录像、路透与分直拍六类现场内容，用接近第一视角的画面，
              还原每一个被热议的瞬间。所有内容以现场氛围记录为主，不进行人物评价。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 text-sm text-accent-300">
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
              {siteIntro.email}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <Link to="/" className="cursor-pointer transition-colors hover:text-accent-300">
                内容分类
              </Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="cursor-pointer text-primary-200 transition-colors hover:text-accent-300">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">关于本站</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              <li>
                <Link to="/about" className="cursor-pointer text-primary-200 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#principles" className="cursor-pointer text-primary-200 transition-colors hover:text-accent-300">
                  内容原则
                </Link>
              </li>
              <li>
                <Link to="/about#faq" className="cursor-pointer text-primary-200 transition-colors hover:text-accent-300">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="cursor-pointer text-primary-200 transition-colors hover:text-accent-300">
                  投稿与联系
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>本站内容仅用于现场氛围记录与分享，不提供下载，不支持任何形式的二次剪辑与商用。</p>
          <p>© 2026 {siteIntro.brandName} · 保留所有权利</p>
        </div>
      </div>
    </footer>
  );
}